import React, { useState } from "react";
import FormInput from "../common/FormInput";
import { Link, useNavigate } from "react-router-dom";
import { supabase } from "../../lib/supabaseClient";
import "./LoginForm.css"; 

//  1. 파이어베이스 임포트 추가// 수정
import { messaging } from '../../firebase-config'; 
import { getToken } from 'firebase/messaging';



function LoginForm() {
  const [formData, setFormData] = useState({
    userId: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  function handleChange(event) {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  //  2. 알림 권한 요청 및 DB 저장 함수//수정
  const requestNotificationPermission = async (loginId) => {
    try {
      //걍 새로 로그인한 아이디 받아와
      console.log("정말로 함수에 넘어온 loginId 값:", loginId);
      const permission = await Notification.requestPermission();
      
      if (permission === 'granted') {
        const fcmToken = await getToken(messaging, {
          vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY 
        });
        
        console.log("이 기기의 FCM 토큰:", fcmToken);

        const { data, error } = await supabase
          .from('users') 
          .update({ fcm_token: fcmToken })
          .eq('id', loginId) 
          .select();

          console.log("실제 업데이트된 데이터:", data);
          console.log("에러가 났나요?:", error);

        if (error) {
          console.error("토큰 저장 실패:", error.message);
        } else {
          console.log("수파베이스에 FCM 토큰 저장 완료!");
        }
      } else {
        console.log("유저가 알림을 거부했습니다.");
      }
    } catch (error) {
      console.error("알림 설정 중 에러 발생:", error);
    }
  };//

  async function handleSubmit(event){
    event.preventDefault();
    setLoading(true);
    setError(null);

    try {
      // [로그인 2단계 처리]
      // Supabase Auth는 이메일 기반이지만, 사용자에게는 아이디(login_id)를 입력받음
      // 1단계: users 테이블에서 login_id → email 변환 (아이디로 이메일을 역조회)
      const { data: userData, error: userError } = await supabase
        .from("users")
        .select("email, id")
        .eq("login_id", formData.userId)
        .single(); // 아이디는 고유값이므로 반드시 1건만 반환되어야 함

      if (userError || !userData) {
        throw new Error("아이디 또는 비밀번호가 일치하지 않습니다.");
      }

      // 2단계: 조회한 이메일과 입력된 비밀번호로 Supabase Auth 인증 진행
      // 성공 시 Supabase가 세션 토큰을 발급해 localStorage에 자동 저장
      const { data, error: signInError } = await supabase.auth.signInWithPassword({
        email: userData.email,
        password: formData.password,
      });

      if (signInError) {
        throw new Error("아이디 또는 비밀번호가 일치하지 않습니다.");
      }

      // 로그인 성공 후 FCM(Firebase Cloud Messaging) 알림 권한 요청 및 토큰 저장
      // userData.id는 Supabase public.users 테이블의 PK (auth UUID와 동일한 값)
      await requestNotificationPermission(userData.id);

      alert("로그인에 성공했습니다!");
      navigate("/");

    } catch (error) {
      console.error("로그인 에러:", error);
      setError(error.message);
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
    
      <h1 className="login-title">로그인</h1>

      {/* 에러 메시지 표시 영역 */}
      {error && <p className="error-message">{error}</p>}

      <form onSubmit={handleSubmit} className="login-form">
        {/* 아이디 입력 */}
        <FormInput
          type="text"
          name="userId"
          placeholder="아이디..."
          value={formData.userId}
          onChange={handleChange}
        />
        
        {/* 비밀번호 입력 */}
        <FormInput
          type="password"
          name="password"
          placeholder="비밀번호..."
          value={formData.password}
          onChange={handleChange}
        />

        {/* 로그인 버튼 */}
        <button type="submit" className="login-submit-btn" disabled={loading}>
          {loading ? "로그인 중..." : "로그인"}
        </button>
      </form>

      {/* 회원가입 링크  */}
      <div className="login-footer">
        <Link to="/signup" className="signup-text">
          회원가입
        </Link>
      </div>
    </div>
  );
}

export default LoginForm;